import React, {useEffect} from 'react'
import {toast} from "react-toastify";

const GeoLocation = () => {
    let currentStep = 'check_user_permission'; // Tracks the current step in the sequence

    const sendToReactNative = (type = 'check_user_permission') => {
        if (window.ReactNativeWebView?.postMessage) {
            const message = {
                event_name: 'user_location',
                type: type,
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
            console.log(`Sent to React Native: ${type}`);
        } else {
            console.error('ReactNativeWebView is not available.');
        }
    };

// Optional: Listen for messages from React Native
    window.addEventListener('message', (event) => {
        const message = event.data;
        console.log(`Message received from React Native: ${currentStep}`, message);

        switch (currentStep) {
            case 'check_user_permission':
                if (message.status === 'denied') {
                    currentStep = 'request_for_user_permission';
                    sendToReactNative('request_for_user_permission');
                } else if (message.status === 'granted') {
                    currentStep = 'user_location';
                    sendToReactNative('user_location');
                } else if (message.status === 'permanently_denied') {
                    toast.error('Permission permanently denied');
                }
                break;

            case 'request_for_user_permission':
                if (message.status === 'granted') {
                    currentStep = 'user_location';
                    sendToReactNative('user_location');
                } else if (message.status === 'denied') {
                    toast.error('Permission denied again');
                    currentStep = 'request_for_user_permission';
                    sendToReactNative('request_for_user_permission');
                }
                break;

            case 'user_location':
                console.log('User location process complete.');
                break;

            default:
                console.warn('Unexpected step:', currentStep);
        }
    });

// Trigger the first step
    sendToReactNative('check_user_permission');


    return(
        <>
            <div style={{margin:"3rem",display:"flex"}}>
                <div>
                    <button onClick={sendToReactNative}>Fetch Current Location</button>
                </div>
            </div>
        </>
    )
}

export default GeoLocation